import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSearch } from 'react-icons/fi';
import './SearchInput.css';

function SearchInput({
  placeholder = "Service Categories",
  suggestions = [],
  onSearch,
  navigateOnSelect = true
}) {
  const [input, setInput] = useState('');
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (input) {
      setFilteredSuggestions(
        suggestions.filter(suggestion => 
          suggestion.name.toLowerCase().includes(input.toLowerCase())
        )
      );
    } else {
      setFilteredSuggestions(suggestions.slice(0, 5));
    }
  }, [input, suggestions]);

  // helper function → lowercase & remove spaces
  const formatValue = (value) => 
    value.toLowerCase().replace(/\s+/g, '');

  const handleSearch = (e) => {
    e.preventDefault();
    if (input.trim()) {
      navigate(`/categories/${encodeURIComponent(formatValue(input))}`);
    }
  };

  const handleSuggestionClick = (suggestion) => {
    setInput(suggestion.name);
    setShowSuggestions(false);
    
    if (navigateOnSelect) {
      if (suggestion.type === 'main-category') {
        navigate(`/categories/${encodeURIComponent(formatValue(suggestion.name))}`);
      } else if (suggestion.parentCategory) {
        navigate(
          `/dealers?category=${encodeURIComponent(formatValue(suggestion.parentCategory))}` +
          `&service=${encodeURIComponent(formatValue(suggestion.parentService))}` +
          `&subservice=${encodeURIComponent(formatValue(suggestion.name))}`
        );
      }
    }
    
    if (onSearch) {
      onSearch(suggestion);
    }
  };

  return (
    <div className="search-input-container">
      <form className="search-form" onSubmit={handleSearch}>
        <div className="search-input-wrapper">
          <input
            type="text"
            placeholder={placeholder}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onFocus={() => setShowSuggestions(true)}
            onBlur={() => setTimeout(() => setShowSuggestions(false), 200)}
          />
          <button type="submit" className="search-button">
            <FiSearch />
          </button>
        </div>

        {showSuggestions && filteredSuggestions.length > 0 && (
          <div className="suggestions-dropdown">
            {filteredSuggestions.map((suggestion, index) => (
              <div
                key={index}
                className="suggestion-item"
                onClick={() => handleSuggestionClick(suggestion)}
              >
                {suggestion.icon && (
                  <span 
                    className="suggestion-icon" 
                    style={{ color: suggestion.color }}
                  >
                    {suggestion.icon}
                  </span>
                )}
                <span className="suggestion-text">
                  {suggestion.name}
                  {suggestion.parentCategory && (
                    <span className="suggestion-category">
                      {suggestion.parentCategory} → {suggestion.parentService}
                    </span>
                  )}
                </span>
              </div>
            ))}
          </div>
        )}
      </form>
    </div>
  );
}

export default SearchInput;
